module.exports = __webpack_public_path__ + "media/images/85/about-da3cbfccde0cfe250a2da7f563dfe0da.webp";